import api, {isBeaconSupported} from '@js/actions/api';

function sendBeaconOrPromise(url, params) {
    if (isBeaconSupported()) {
        return new Promise((resolve) => {
            api.sendBeacon(url, params);

            resolve();
        });
    } else {
        return api.post(url, params);
    }
}


export const updateTrackingConfiguration = (properties) => (
    sendBeaconOrPromise('/api/v1/tracking/configuration', properties)
);

export const trackConversion = (conversionData) => (
    sendBeaconOrPromise('/api/v1/tracking/conversion', conversionData)
);

export const trackEvent = (name, properties = {}) => (
    sendBeaconOrPromise('/api/v1/tracking/event', {
        name,
        properties
    })
);

export const trackLimitReached = (requiredFunctionality, activity = null) => (
    api.post('/api/v1/tracking/limit-reached', {
        functionality: requiredFunctionality,
        activity
    })
);

export const trackTrialAction = (actionType, origin = 'banner') => (
    sendBeaconOrPromise('/api/v1/tracking/trial-action', {
        action_type: actionType,
        origin: origin
    })
);

export const trackPaymentAttempt = (paymentTool, paymentMethod = null) => (
    sendBeaconOrPromise('/api/v1/tracking/payment-attempt', {
        paymentTool,
        paymentMethod
    })
);

export const trackPaymentError = (paymentError) => (
    sendBeaconOrPromise('/api/v1/tracking/payment-error', {
        paymentError
    })
);
